module.exports = __webpack_public_path__ + "img/join-from.ae655d08.png";